import React, { useEffect, useState, useCallback } from 'react'
import { supabase } from '../supabaseClient'

const STATUS_META = {
  sent:                  { bg:'rgba(16,185,129,0.12)',  color:'#34d399', icon:'✅', label:'Sent' },
  simulated:             { bg:'rgba(30,144,255,0.1)',   color:'#5aabff', icon:'🧪', label:'Simulated' },
  skipped_no_phone:      { bg:'rgba(244,163,53,0.1)',   color:'#f4a335', icon:'⚠',  label:'No Phone' },
  skipped_invalid_phone: { bg:'rgba(244,163,53,0.1)',   color:'#f4a335', icon:'⚠',  label:'Invalid Phone' },
  failed:                { bg:'rgba(239,68,68,0.1)',    color:'#f87171', icon:'❌', label:'Failed' },
}

function fmtTime(ts) {
  if (!ts) return '—'
  return new Date(ts).toLocaleString('en-IN', { day:'2-digit', month:'short', hour:'2-digit', minute:'2-digit', hour12:true })
}

export default function ReminderLog() {
  const [logs,       setLogs]       = useState([])
  const [loading,    setLoading]    = useState(true)
  const [dateFrom,   setDateFrom]   = useState('')
  const [statusFilter, setStatusFilter] = useState('all')

  const load = useCallback(async () => {
    setLoading(true)
    let q = supabase.from('class_reminder_log')
      .select('*, classes(title, batch, class_date, start_time), profiles:student_id(full_name, email)')
      .order('created_at', { ascending: false })
      .limit(300)
    if (dateFrom) q = q.gte('created_at', dateFrom + 'T00:00:00')
    if (statusFilter !== 'all') q = q.eq('status', statusFilter)
    const { data } = await q
    setLogs(data || [])
    setLoading(false)
  }, [dateFrom, statusFilter])

  useEffect(() => { load() }, [load])

  const inp = { background:'var(--bg-input)', border:'0.5px solid rgba(var(--fg-rgb),0.1)', borderRadius:'10px', padding:'8px 12px', fontSize:'13px', color:'rgba(var(--fg-rgb),var(--a85))', outline:'none', fontFamily:'inherit', colorScheme:'dark' }

  const counts = logs.reduce((acc, l) => { acc[l.status] = (acc[l.status]||0) + 1; return acc }, {})

  return (
    <div style={{ marginTop:'14px' }}>
      <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:'16px', flexWrap:'wrap', gap:'10px' }}>
        <div>
          <div style={{ fontSize:'16px', fontWeight:700, color:'rgba(var(--fg-rgb),var(--a85))' }}>📲 WhatsApp Reminder Log</div>
          <div style={{ fontSize:'12px', color:'rgba(var(--fg-rgb),var(--a30))', marginTop:'2px' }}>Every reminder attempt sent 2 hours before each class</div>
        </div>
        <button onClick={load} style={{ fontSize:'12px', padding:'7px 14px', borderRadius:'9px', background:'rgba(var(--fg-rgb),0.06)', color:'rgba(var(--fg-rgb),var(--a50))', border:'none', cursor:'pointer', fontFamily:'inherit' }}>↻ Refresh</button>
      </div>

      <div style={{ display:'grid', gridTemplateColumns:'repeat(5,1fr)', gap:'10px', marginBottom:'16px' }}>
        {Object.entries(STATUS_META).map(([key, meta]) => (
          <div key={key} style={{ background:'rgba(var(--fg-rgb),0.04)', border:'0.5px solid rgba(var(--fg-rgb),0.07)', borderRadius:'12px', padding:'12px', textAlign:'center' }}>
            <div style={{ fontSize:'20px', fontWeight:800, color:meta.color }}>{counts[key]||0}</div>
            <div style={{ fontSize:'9px', color:'rgba(var(--fg-rgb),var(--a30))', marginTop:'3px', letterSpacing:'0.05em' }}>{meta.label.toUpperCase()}</div>
          </div>
        ))}
      </div>

      <div style={{ display:'flex', gap:'8px', flexWrap:'wrap', marginBottom:'14px', alignItems:'center' }}>
        <select value={statusFilter} onChange={e=>setStatusFilter(e.target.value)} style={{ ...inp, width:'auto' }}>
          <option value="all">All Statuses</option>
          {Object.entries(STATUS_META).map(([k,v]) => <option key={k} value={k}>{v.label}</option>)}
        </select>
        <input type="date" value={dateFrom} onChange={e=>setDateFrom(e.target.value)} style={inp} title="From date" />
        {(dateFrom || statusFilter !== 'all') && (
          <button onClick={()=>{setDateFrom('');setStatusFilter('all')}} style={{ fontSize:'11px', padding:'7px 12px', borderRadius:'8px', background:'rgba(239,68,68,0.1)', color:'#f87171', border:'none', cursor:'pointer', fontFamily:'inherit' }}>✕ Clear</button>
        )}
      </div>

      {loading ? (
        <div style={{ textAlign:'center', padding:'4rem', color:'rgba(var(--fg-rgb),var(--a20))', fontSize:'13px' }}>Loading reminder log...</div>
      ) : logs.length === 0 ? (
        <div style={{ textAlign:'center', padding:'4rem', color:'rgba(var(--fg-rgb),var(--a20))', fontSize:'13px' }}>No reminders sent yet. They'll appear here once the scheduler starts running.</div>
      ) : (
        <div style={{ background:'rgba(var(--fg-rgb),0.03)', border:'0.5px solid rgba(var(--fg-rgb),0.07)', borderRadius:'14px', overflow:'hidden' }}>
          <div style={{ display:'grid', gridTemplateColumns:'1.5fr 1fr 1fr 110px 130px', padding:'10px 16px', background:'rgba(var(--fg-rgb),0.04)', borderBottom:'0.5px solid rgba(var(--fg-rgb),0.07)' }}>
            {['Class','Student','Phone','Status','Sent At'].map(h => (
              <div key={h} style={{ fontSize:'10px', fontWeight:700, color:'rgba(var(--fg-rgb),var(--a30))', letterSpacing:'0.08em', textTransform:'uppercase' }}>{h}</div>
            ))}
          </div>
          {logs.map((l, i) => {
            const meta = STATUS_META[l.status] || { bg:'rgba(var(--fg-rgb),0.06)', color:'#aaa', icon:'•', label:l.status }
            return (
              <div key={l.id} style={{ display:'grid', gridTemplateColumns:'1.5fr 1fr 1fr 110px 130px', padding:'10px 16px', borderBottom: i < logs.length-1 ? '0.5px solid rgba(var(--fg-rgb),0.04)' : 'none', alignItems:'center' }}>
                <div>
                  <div style={{ fontSize:'12px', fontWeight:600, color:'rgba(var(--fg-rgb),var(--a80))' }}>{l.classes?.batch || l.classes?.title || '—'}</div>
                  <div style={{ fontSize:'10px', color:'rgba(var(--fg-rgb),var(--a30))' }}>{l.classes?.class_date} {l.classes?.start_time}</div>
                </div>
                <div style={{ fontSize:'12px', color:'rgba(var(--fg-rgb),var(--a70))' }}>{l.profiles?.full_name || '—'}</div>
                <div style={{ fontSize:'11px', color:'rgba(var(--fg-rgb),var(--a40))', fontFamily:"'DM Mono',monospace" }}>{l.phone || '—'}</div>
                <span style={{ fontSize:'10px', fontWeight:700, padding:'3px 8px', borderRadius:'6px', background:meta.bg, color:meta.color, width:'fit-content' }}>{meta.icon} {meta.label}</span>
                <div style={{ fontSize:'11px', color:'rgba(var(--fg-rgb),var(--a40))' }}>{fmtTime(l.created_at)}</div>
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}
